import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({ providedIn: "root" })
export class CompleteVerificationConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	showVerifyNotification(): boolean {
		return this.configService.get((x) => x.common.payment.showVerifyNotification, false);
	}
}
